import { Formik } from "formik";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  Accordion,
  Button,
  Col,
  Form,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import * as apicall from "../../components/Apicall";
import { toast } from "react-toastify";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import { FaEnvelope, FaGlobe, FaMapMarkerAlt, FaPhoneAlt, FaRegCalendarAlt } from "react-icons/fa";
import { Dropdown } from "primereact/dropdown";
import UserContext from "../../components/context/UserContext";
import BookingCalendar from "../Dashboard/BookingCalendar";
import RotateDevicePopup from "../../components/RotateDevicePopup/RotateDevicePopup";
import OtpInput from "react-otp-input";
import Loader from "../../components/Loader/Loader";
import {google_places_key} from '../../constants/Constants';
import { Autocomplete, LoadScript ,useJsApiLoader } from "@react-google-maps/api";


function CustomerBookings() {
  let service = JSON.parse(localStorage.getItem("services"));
  let vendor_id = JSON.parse(localStorage.getItem("userId"));

  // const [searchParams] = useSearchParams();
  // let group_id = searchParams.get("group_id");
  let { group_id } = useParams();
  // let display_booking_id = group_id;
  if (group_id) {
    group_id = group_id?.split("_")[group_id?.split("_")?.length - 1];
  }

  const [services, setServices] = useState(service);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
const vendorProfile = JSON.parse(localStorage.getItem("vendorProfile")) || {};

const taxPercentage = parseFloat(vendorProfile?.tax || 0); 
  const [initialValues, setInitialValues] = useState({
    partner: 1,
    org_id: "",
    userName: "",
    mobileNumber: "",
    email: "",
    house_no: "",
    area: "",
    location: "",
    location_id: "",
    state: "",
    landmark: "",
    country: 1,
    lat: "",
    lng: "",
    // time: "",
    status: 0,
    payment: 0,
  });
  const [loading, setLoading] = useState(false);
  const [selectedService, setSelectedService] = useState(service?.[0] || {});
  const [initialServiceData, setInitialServiceData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [activeType, setActiveType] = useState("null");
  const [groupedData, setGroupedData] = useState({});
  const sectionsRef = useRef({});
  const scrollContainerRef = useRef(null);
  const isScrollingRef = useRef(false);
  let isScroll = false;
  const [dateSelect, setDateSelect] = useState("");
  const [timeSelect, setTimeSelect] = useState("");
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [otp, setOtp] = useState("");
  const [errorMessages, setErrorMessage] = useState("");
  const [timeRange, setTimeRange] = useState({ startTime: "", endTime: "" });

  const [userId, setUserId] = useState(null);
  const [locationId, setLocationId] = useState(null);
  const [Otpres, setOTPresult] = useState(null);
  const renderOtpInput = (props) => <input {...props} />;
  const [loader, setLoader] = useState(false);
  const [discount, setDiscount] = useState(0);
  const [priceSection, setPriceSection] = useState([]);
  const [showCalender, setShowCalender] = useState(false);
  const [providerSelected, setProviderSelected] = useState([]);
    const [locationError, setLocationError] = useState("");
  
  const { id } = useParams();
  const isEditing = Boolean(id);
  let navigate = useNavigate();
  const { vendor, refreshVendorData } = useContext(UserContext);
  const [activeAccordion, setActiveAccordion] = useState(
    group_id ? ["1"] : ["0"] // can have multiple keys open
  );
  const [currency, setCurrency] = useState("AED");
  const autocompleteRef = useRef(null);
  
  const onLoad = (autocomplete) => {
    autocompleteRef.current = autocomplete;
  };
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: google_places_key,
    libraries: ["places"],
  });
  const onPlaceChanged = (setFieldValue) => {
    if (!autocompleteRef.current) return;
  
    const place = autocompleteRef.current.getPlace();
    if (!place || !place.address_components) return;
  
    let street = place.formatted_address || "";
    let area = "";
    let state = "";
    let country = "";
    let lat = place.geometry?.location?.lat();
    let lng = place.geometry?.location?.lng();
  
    place.address_components.forEach((comp) => {
      const types = comp.types;
  
      if (types.includes("sublocality") || types.includes("locality")) {
        area = comp.long_name;
      }
  
      if (types.includes("administrative_area_level_1")) {
        state = comp.long_name;
      }
  
      if (types.includes("country")) {
        country = comp.short_name?.toLowerCase(); //  "in" / "ae"
      }
    });
  
    //  expected country based on currency
    const expectedCountry = currency === "INR" ? "in" : "ae";
  
    // console.log("Selected:", country, "Expected:", expectedCountry);
  
    // VALIDATION
    if (!country || country !== expectedCountry) {
      setLocationError(
        currency === "INR"
          ? "Please select a location within India"
          : "Please select a location within UAE"
      );
  
      setFieldValue("location", "");
      setFieldValue("area", "");
      setFieldValue("state", "");
      setFieldValue("lat", "");
      setFieldValue("lng", "");
  
      return;
    }
  
    //  CLEAR ERROR
    setLocationError("");
  
    //  SET VALUES
    setFieldValue("location", street);
    setFieldValue("area", area);
    setFieldValue("state", state);
    setFieldValue("country", country);
    setFieldValue("lat", lat);
    setFieldValue("lng", lng);
  };

  useEffect(() => {
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    setCurrency(userDetails?.currency);
  }, []);

 const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // Toggle accordion without closing others
  const handleToggleAccordion = (key) => {
    if (activeAccordion.includes(key)) {
      // Remove key if already open (optional: comment this if you don't want closing on header click)
      setActiveAccordion(activeAccordion.filter((k) => k !== key));
    } else {
      // Add key to array
      setActiveAccordion([...activeAccordion, key]);
    }
  };
  const openAccordion1 = () => {
    if (!activeAccordion.includes("1")) {
      setActiveAccordion([...activeAccordion, "1"]);
    }
  };
    const cleanCrewSlots = (slots) => {
    const grouped = {};

    // Step 1: Group by provider_id
    slots.forEach((slot) => {
      const id = slot.extendedProps.provider_id;
      if (!grouped[id]) grouped[id] = [];
      grouped[id].push(slot);
    });

    let result = [];

    // Step 2: Process each crew separately
    Object.values(grouped).forEach((group) => {
      const bookedSlots = group.filter((s) => s.status === 2);

      const cleaned = group.filter((slot) => {
        // keep booked slots
        if (slot.status === 2) return true;

        // remove overlap only within same crew
        const isOverlapping = bookedSlots.some((booked) => {
          return (
            new Date(slot.start) < new Date(booked.end) &&
            new Date(slot.end) > new Date(booked.start)
          );
        });

        return !isOverlapping;
      });

      result.push(...cleaned);
    });

    return result;
  };
    const crewCount = providerSelected?.length || 1;

  const [filteredAppointments, setFilteredAppointments] = useState([
    {
      title: "Worker 1",
      search: "Worker 1",
      start: "2025-11-27T09:00:00",
      end: "2025-11-27T09:30:00",
      status: 10,
      className: "status-15",
      extendedProps: {
        search: "Worker 1",
        start: "2025-11-27T09:00:00",
      },
    },
    {
      title: "Worker 2",
      search: "Worker 2",
      start: "2025-11-27T09:00:00",
      end: "2025-11-27T09:30:00",
      status: 10,

      className: "status-15",
      extendedProps: {
        search: "Worker 1",
        start: "2025-11-27T09:00:00",
      },
    },
    {
      title: "Worker 1",
      search: "Worker 1",
      start: "2025-11-27T10:00:00",
      end: "2025-11-27T10:30:00",
      status: 15,
      className: "status-15",
      extendedProps: {
        search: "Worker 1",
        start: "2025-11-27T10:00:00",
      },
    },
  ]);
  const [initialAppointments, setInitialAppointments] = useState([]);
  const [partner_id, setPartner_id] = useState(1);
  const [partners, setPartners] = useState([]);
  const [user_id, setUser_id] = useState(0);
  const flagCount = useRef(0);
  const [bookingStatus, setBookingStatus] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState([]);
  const [firstLocation, setFirstLocation] = useState(null);
  const [existingData, setExistingData] = useState([]);
  const [open, setOpen] = useState(false);
  const [maxTime, setMaxTime] = useState(30);
  const [showOrderConf, setShowOrderConf] = useState(false);
  const [modelData, setModelData] = useState({});
  const [display_booking_id, setDisplay_booking_id] = useState("");
  const [editable, setEditable] = useState(true);
  //   const user = JSON.parse(localStorage.getItem("userDetails"));
  const [vendorDetails, setVendorDetails] = useState(null);
console.log(vendorDetails,"vendorDetails")
  useEffect(() => {
    const data = localStorage.getItem("userDetails");
    if (data) {
      setVendorDetails(JSON.parse(data));
    }
  }, []);
  // console.log("initialValues--", initialValues);

  // console.log("timeSelect-------------", timeSelect);

  // Validation Schema
  const validationSchema = Yup.object().shape({
    partner: Yup.string().required("Profile is required"),
    mobileNumber: Yup.string()
      .required("Phone Number is required")
      // .matches(/^[0-9]+$/, "Phone Number must be numeric")
      .test("country-specific-length", function (value) {
        if (!value) return true;
        const cleanedValue = value.replace(/\D/g, "");
        if (cleanedValue.startsWith("91")) {
          return (
            cleanedValue.length >= 12 ||
            this.createError({
              message:
                "Please enter a valid Indian phone number (min 10 digits)",
            })
          );
        }
        if (cleanedValue.startsWith("971")) {
          return (
            cleanedValue.length >= 12 ||
            this.createError({
              message: "Please enter a valid UAE phone number (min 9 digits)",
            })
          );
        }
        // Default: minimum 10 digits (including country code)
        return (
          cleanedValue.length >= 10 ||
          this.createError({
            message: "Please enter a valid phone number (min 10 digits)",
          })
        );
      }),
    userName: Yup.string()
      .required("Customer name is required")
      .min(2, "Customer name must be at least 2 characters")
      .max(20, "Customer name must not exceed 20 characters"),

    house_no: Yup.string()
      .required("Street / House no. is required")
      // .min(5, "Street address must be at least 5 characters")
      .max(100, "Street address must not exceed 100 characters"),

    area: Yup.string().required("Area is required"),
    location: Yup.string().required("Location is required"),
  state: Yup.string().required(
  currency === "INR" ? "State is required" : "Emirate is required"
),
    country: Yup.string().required("Country is required"),
    // time: Yup.string().required("Time is required"),

    lat: Yup.string().test(
      "is-valid-latitude",
      "Invalid latitude value",
      (value) => {
        if (!value) return true;
        const numValue = parseFloat(value);
        return !isNaN(numValue) && numValue >= -90 && numValue <= 90;
      }
    ),
    lng: Yup.string().test(
      "is-valid-longitude",
      "Invalid longitude value",
      (value) => {
        if (!value) return true;
        const numValue = parseFloat(value);
        return !isNaN(numValue) && numValue >= -180 && numValue <= 180;
      }
    ),
    // status: Yup.string().required("Status is required"),
    // payment: Yup.string().required("Payment is required"),
  });

  useEffect(() => {
    getAllServices();
  }, [partner_id]);

  useEffect(() => {
    fetchServiceData(selectedService);
  }, [selectedService]);

  useEffect(() => {
    let today = new Date();
    let d1 = today.toLocaleDateString("en-GB").split(/[\/\-\.]/);
    let d2 = `${d1[2]}-${d1[1]}-${d1[0]}`;
    setDateSelect(d2);
    // getAllServices();
    fetchPartners();
  }, [group_id]);

  useEffect(() => {
    const scrollEl = scrollContainerRef.current;
    if (!scrollEl) return;

    const handleScroll = () => {
      if (isScrollingRef.current) return;
      if (isScroll) return;

      // console.log("scroll------");
      const scrollPos = scrollEl.scrollTop; // adjust offset

      for (const type of serviceTypes) {
        const section = sectionsRef.current[type];
        if (section) {
          const { offsetTop, offsetHeight } = section;
          if (scrollPos >= offsetTop && scrollPos < offsetTop + offsetHeight) {
            setActiveType(type);
            break;
          }
        }
      }
    };
    scrollEl.addEventListener("scroll", handleScroll);
    return () => scrollEl.removeEventListener("scroll", handleScroll);
  }, [serviceTypes]);
  // }, [serviceTy/pes]);

  useEffect(() => {
    arrangeData(true);
  }, [initialServiceData]);

  useEffect(() => {
    setProviderSelected([]);
  }, [selectedService]);

  useEffect(() => {
    if (providerSelected?.length > 0) {
      setTimeSelect(providerSelected[0]?.start?.split("T")?.[1]);
    }
  }, [providerSelected]);

  useEffect(() => {
    arrangeData();
    getPrice();
  }, [serviceData]);

  const getStatusColors = (status) => {
    // Define color schemes for different statuses with requested light colors
    const statusColors = {
      //  Green - completed
      1: {
        bgColor: "rgba(255, 255, 204, 0.5)",
        borderColor: "#CCCC00",
        textColor: "#666600",
      },
      //Selected - Light blue
      2: {
        bgColor: "#FFF0FD",
        borderColor: "#92007E",
        textColor: "#92007E",
      },
      // Cancelled / red - Not avaiable
      3: {
        bgColor: "#FDEDED",
        borderColor: "#FF0000",
        textColor: "#FF0000",
      },
      // Break
      6: {
        bgColor: "#FDEDED",
        borderColor: "#FF0000",
        textColor: "#FF0000",
      },

      10: {
        bgColor: "#FDEDED",
        borderColor: "#FF0000",
        textColor: "#FF0000",
      },
      // Checked In (11) - Light blue
      11: {
        bgColor: "#FFF0FD",
        borderColor: "#92007E",
        textColor: "#92007E",
      },
      // Cancelled (14) - Light red
      14: {
        bgColor: "rgba(255, 204, 204, 0.5)",
        borderColor: "#CC0000",
        textColor: "#990000",
      },
      // No Show (15) - Light orange
      12: {
        bgColor: "F2F9FF",
        borderColor: "#037FE8",
        textColor: "#037FE8",
      },
      // Completed/Checked Out (15) - Light green
      15: {
        bgColor: "rgba(255, 255, 204, 0.5)",
        borderColor: "#CCCC00",
        textColor: "#666600",
      },
      // Default - Light gray
      default: {
        bgColor: "rgba(230, 230, 230, 0.5)",
        borderColor: "#999999",
        textColor: "#666666",
      },
    };

    return statusColors[status] || statusColors.default;
  };

  const appointments = filteredAppointments?.map((item) => {
    const colors = getStatusColors(item?.status);

    return {
      title: `${item.title?.trim()}`,
      search: item.title?.trim(),
      start: item?.start,
      end: item?.end,
      backgroundColor: colors.bgColor,
      borderColor: colors.borderColor,
      textColor: colors.textColor,
      extendedProps: {
        ...item,
      },
      // Optional: Add event class for additional styling
      className: `status-${item?.status || "default"}`,
    };
  });

  async function getAllServices() {
    try {
      setLoading(true);
      const response = await apicall.get(
        `get_ezp_service?partner_id=${partner_id}`
      );
      setLoading(false);
      if (response.success && response.data) {
        setServices(response.data);
        if (group_id) {
          getDataByID(response.data);
        } else {
          setSelectedService(response.data?.[0]);
          fetchServiceData(response.data?.[0]);

          setInitialValues({
            partner: partner_id,
            org_id: "",
            userName: "",
            mobileNumber: "",
            email: "",
            house_no: "",
            area: "",
            location: "",
            location_id: "",
            state: "",
            landmark: "",
            country: 1,
            lat: "",
            lng: "",
            status: "",
            payment: "",
          });
        }
      } else {
        setServices([]);
      }
    } catch (e) {
      console.log("e----", e);
    } finally {
      setLoading(false);
    }
  }

  async function getDataByID(allServicesData) {
    try {
      setLoading(true);
      const response = await apicall.get(
        `get_ezp_booking_by_id?group_id=${group_id}`
      );
      setLoading(false);
      if (response.success && response.data) {
        // console.log("response.data----", response.data);

        setExistingData(response?.data || []);
        let {
          customer_id,
          partner,
          org_id,
          user_name,
          email,
          phone_number,
          house_no,
          area,
          state,
          location,
          location_id,
          landmark,
          status,
          payment,
          lat,
          lng,
          service_id,
          service_date,
          service_time,
          discount,
          provider,
          display_booking_id,
          editable,
          service_type_name,
        } = response.data[0];
        let d1 = {
          partner: partner,
          org_id: org_id,
          userName: user_name,
          mobileNumber: phone_number,
          email: email,
          house_no: house_no,
          area: area,
          location: location,
          location_id: location_id,
          state: state,
          landmark: landmark,
          country: 1,
          lat: lat,
          lng: lng,
          status: status,
          payment: payment,
        };
        setInitialValues(d1);
        setDateSelect(service_date);
        setTimeSelect(service_time);
        setDiscount(discount);
        setPartner_id(partner);
        setDisplay_booking_id(display_booking_id);
        setEditable(editable);
        setUser_id(customer_id);
        setActiveType(service_type_name || "null");

        let providers = provider?.split(",")?.map((ele) => Number(ele));

        let selectedId;
        for (let i of allServicesData) {
          if (i.id === service_id) {
            selectedId = service_id;
            setSelectedService(i);
          }
        }
        let q1 = `getWokerAvailableSlots?date=${service_date}`;
        if (selectedId) {
          q1 += `&&service_id=${selectedId}`;
        }
        // setLoading(true);
        let getWorkerAvailable = await apicall.get(q1);

        let updatedData = getWorkerAvailable?.data || [];

        setInitialAppointments(getWorkerAvailable?.data || []);
        let dt = `${service_date}T${service_time}:00`;
        // console.log("dt---", dt);

        let p1 = [];
        for (let i of providers) {
          for (let j of updatedData) {
            if (i === j?.extendedProps?.provider_id && dt === j.start) {
              j.status = 2;
              p1.push(j);
            }
          }
        }
        // console.log("p1---", p1);
        setProviderSelected(p1);

        if (!editable) {
          let ans = updatedData.filter((i) => {
            let hours = timeSelect.split(":")[0];
            let mins = timeSelect.split(":")[1];

            let res = i.start.split("T")[1];
            console.log(
              "res--",
              res,
              `${hours}:${mins}:00`,
              res === `${hours}:${mins}:00`
            );
            return res === `${hours}:${mins}:00`;
            //   if (res === `${hours}:${mins}:00`) {
            //   i.start = i.start.split("T")[0] + "T" + `${hours}:${mins}:00`;
            // }
          });
          updatedData = ans;
        }

        setFilteredAppointments(updatedData || []);
      } else {
      }
    } catch (e) {
      console.log("e----", e);
    } finally {
      setLoading(false);
    }
  }

  // console.log("timeSelect==---------", timeSelect);

  function getPrice() {
    try {
      let prices = [];
      let total = 0;
      for (let eachData of serviceData) {
        if (eachData?.added) {
          let name = eachData.service_name + "- ";
          if (
            eachData.service_type_name &&
            eachData.service_type_name !== "null"
          ) {
            name += eachData.service_type_name + "- ";
          }
          name += eachData.service_offering_name;
          prices.push({
            name: name,
            service_id: eachData.service_id,
            service_name: eachData.service_name,
            service_type_id: eachData.service_type_id,
            service_type_name: eachData.service_type_name,
            service_offering_id: eachData.service_offering_id,
            service_offering_name: eachData.service_offering_name,
            amount: eachData.amount,
          });
          total = parseFloat(total) + parseFloat(eachData.amount);
        }
      }
const taxAmount = (parseFloat(total) * taxPercentage) / 100;

      if (prices?.length > 0) {
        prices.push({
          name: `Tax (${taxPercentage}%)`,
           amount: taxAmount.toFixed(2),
        });

        prices.push({
          name: "Discount",
          amount: discount,
        });

        let t1 =
          parseFloat(total) +
          taxAmount-
          parseFloat(discount || 0);
          
        t1 = parseFloat(t1).toFixed(2);

        prices.push({
          name: "Total",
          amount: t1,
        });
      }
      total = 0;

      setPriceSection(prices);
    } catch (e) {
      console.log("e-----", e);
    }
  }

  async function arrangeData(d1) {
    let g1 = serviceData.reduce((acc, item) => {
      // console.log("acc--", acc);
      let { service_type_name } = item;
      // console.log(service_type_name);
      if (!acc[service_type_name]) acc[service_type_name] = [];

      if (d1) item.added = false;
      acc[service_type_name].push(item);
      return acc;
    }, {});

    setServiceTypes(Object.keys(g1));
    setGroupedData(g1);
  }

  useEffect(() => {
    setActiveType(serviceTypes[0] || "null");
  }, []);

  useEffect(() => {
    const initializeData = async () => {
      try {
        await Promise.all([
          fetchCountries(),
          getBookingStatus(),
          getPaymentStatus(),
        ]);
      } catch (error) {
        console.error("Error initializing data:", error);
        toast.error("Failed to initialize form data");
      }
    };

    initializeData();
  }, []);

  const fetchServiceData = async (data, partnerID = 1) => {
    try {
      if (data?.service_id) {
        let p1 = partner_id ? partner_id : partnerID;
        setLoading(true);
        const response = await apicall.get(
          `offeringFromService?service_id=${data?.service_id}&&is_partner=true&&partner_id=${p1}`
        );
        setLoading(false);

        // console.log("existingData----->>>>", existingData);
        let copyResponse;
        if (response?.data) {
          copyResponse = JSON.parse(JSON.stringify(response?.data));
        }

        let offering_id = [];
        let type_name;

        if (response.success && copyResponse) {
          for (let i of existingData) {
            for (let j of copyResponse) {
              if (i.service_offering_id === j.service_offering_id) {
                // console.log("is there-----");
                j.added = true;
                if (!offering_id.includes(i.service_offering_id)) {
                  j.amount = Number(i.price);
                  offering_id.push(i.service_offering_id);
                }
                break;
              }
            }
          }
          // console.log("offering_id---", offering_id);
          console.log("copyResponse---", copyResponse);

          let c1 = copyResponse?.map((ele) => {
            if (offering_id.includes(ele?.service_offering_id)) {
              if (!type_name) {
                type_name = ele?.service_type_name;
                setActiveType(ele?.service_type_name);
              }

              return { ...ele, added: true };
            } else {
              return { ...ele, added: false };
            }
          });

          let sumTime = 0;
          for (let i of copyResponse) {
            if (i?.added) {
              let t1 = i?.time_required + i?.buffer;
              sumTime += t1;
            }
          }
          setMaxTime(sumTime);

          if (!type_name) {
            setActiveType(
              copyResponse[0]?.service_type_name
                ? copyResponse[0]?.service_type_name
                : "null"
            );
          }

          setServiceData(c1);
        } else {
          setServiceData([]);
        }
      }
    } catch (error) {
      console.log("err---", error);
      toast.error("Failed to fetch service offerings....");
      setInitialServiceData([]);
      setServiceData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchPartners = async () => {
    try {
      const response = await apicall.get("partners");
      setPartners(response.data);

      if (!group_id) {
        setPartner_id(response?.data[0]?.id);
        setInitialValues({
          partner: response?.data[0]?.id,
          org_id: "",
          userName: "",
          mobileNumber: "",
          email: "",
          house_no: "",
          area: "",
          location: "",
          location_id: "",
          state: "",
          landmark: "",
          country: 1,
          lat: "",
          lng: "",
          status: "",
          payment: "",
        });
      }
    } catch (error) {
      console.error("Error fetching fetchPartners:", error);
      toast.error("Failed to fetch fetchPartners");
    }
  };

  const getBookingStatus = async () => {
    try {
      const response = await apicall.get("get_ezp_booking_status");

      if (response.success) {
        setBookingStatus(response.data);
      } else {
        setBookingStatus([]);
      }
    } catch (error) {
      console.error("Error fetching Booking Status:", error);
      toast.error("Failed to fetch Booking Status:");
    }
  };

  const getPaymentStatus = async () => {
    try {
      const response = await apicall.get("get_ezp_payment_status");
      if (response.success) {
        setPaymentStatus(response.data);
      } else {
        setPaymentStatus([]);
      }
    } catch (error) {
      console.error("Error fetching Booking Status:", error);
      toast.error("Failed to fetch Booking Status:");
    }
  };

  const fetchCountries = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await apicall.get("country", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.success) {
        const countriesData = Array.isArray(response.data)
          ? response.data
          : response.data?.countries || [];

        setCountries(countriesData);

        // Find UAE in the countries list
        // const uaeCountry = countriesData.find(
        //   (country) =>
        //     country.name.toLowerCase() === "united arab emirates" ||
        //     country.name.toLowerCase() === "uae"
        // );

        // If UAE is found, set it as default
        // if (uaeCountry) {
        //   // setInitialValues((prev) => ({
        //   //   ...prev,
        //   //   country: uaeCountry.country_id.toString(),
        //   // }));
        //   // Fetch states for UAE
        //   fetchStates(uaeCountry.country_id.toString());
        // } else if (countriesData.length > 0) {
        //   // Fallback to first country if UAE not found
        //   // setInitialValues((prev) => ({
        //   //   ...prev,
        //   //   country: countriesData[0].country_id.toString(),
        //   // }));
        //   fetchStates(countriesData[0].country_id.toString());
        // }
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
      toast.error("Failed to fetch countries");
    }
  };

  const fetchStates = async (countryId1) => {
    try {
      // console.log("countryId----", countryId);
      let countryId = currency === "INR" ? 2 : 1;
      const token = localStorage.getItem("token");
      const response = await apicall.get(`state/${countryId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.success && response.data) {
        setStates(response.data);
      } else {
        setStates([]);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
      toast.error("Failed to fetch states");
      setStates([]);
    }
  };

  const handleCountryChange = (e, setFieldValue) => {
    const countryId = e.value;

    setFieldValue("country", countryId);
    if (countryId) {
      fetchStates(countryId);
      // Reset state and city when country changes
      // setStates([]);
      // setCities([]);
      // setFieldValue("state", "");
      // setFieldValue("area", "");
    } else {
      // setStates([]);
      // setCities([]);
    }
  };
  useEffect(() => {
    if (initialValues.country) {
      fetchStates(initialValues.country);
    }
  }, [initialValues.country]);
  const handleStateChange = (e, setFieldValue) => {
    const stateId = e.target.value;

    setFieldValue("state", stateId);
    if (stateId) {
      // fetchCities(stateId);
      // Reset city when state changes
      // setCities([]);
      // setFieldValue("city", "");
    } else {
      // setCities([]);
    }
  };

  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };

  const get_user_details = async (ph_number, setFieldValue) => {
    const response = await apicall.get(
      `ezp_get_users_details/${ph_number}/${vendor_id}`
    );

    console.log("first---response---", response);

    if (response.status === 200 && response.data.length > 0) {
      const user = response.data[0];
      const fullName = `${user.first_name} ${user.middle_name || ""} ${
        user.last_name || ""
      }`.trim();
      // const age = calculateAge(user.dob);
      const gender =
        user.gender === null
          ? "Not Available"
          : user.gender === 1
          ? "Male"
          : "Female";

      setUser_id(user?.id || 0);

      // Update form values using Formik's setFieldValue
      setFieldValue("userName", fullName);
      setFieldValue("email", user?.email || "");
      setFieldValue("house_no", user?.house_no || "");
      setFieldValue("area", user?.area || "");
      setFieldValue("landmark", user?.landmark || "");
      setFieldValue("state", user?.state || "");
      setFieldValue("location", user?.location || "");
      setFieldValue("state", user?.state || "");
      // setFieldValue("age", age.toString());
      setFieldValue("lat", user?.lat || "");
      setFieldValue("lng", user?.lng || "");
      setFieldValue("gender", gender);
      setFieldValue("location_id", user?.location_id || "");

      let d1 = {
        house_no: user?.house_no || "",
        area: user?.area || "",
        location: user?.location || "",
        state: user?.state || "",
        landmark: user?.landmark || "",
        lat: user?.lat || "",
        lng: user?.lng || "",
      };
      setFirstLocation(d1);

      // setSelectedUserId(user.id);

      // // Also update formData state for consistency
      // setFormData((prev) => ({
      //   ...prev,
      //   userName: fullName,
      //   age: age.toString(),
      //   gender: gender,
      // }));
    } else {
      setFieldValue("userName", "");
      setFieldValue("age", "");
      setFieldValue("gender", "");
    }
  };

  const debouncedCheckUserExists = useCallback(
    debounce(async (field, value, setFieldValue, setFieldError) => {
      try {
        get_user_details(value, setFieldValue);
      } catch (error) {
        console.error(`Error in debounced check for ${field}:`, error);
      }
    }, 500),
    []
  );
  const verifyOtp = async () => {
    if (otp.length !== 6) {
      setErrorMessage("Please enter 6-digit OTP.");
      return;
    }
    try {
      setLoader(true);

      const response = await apicall.post(
        {
          step: "verifyOtp",
          user_id: Otpres.user_id,
          mobileNumber: modelData.mobileNumber,
          otp: otp,
          role: Otpres?.role,
          twilioService_id: Otpres.twilioService_id,
        },
        "create_customer_booking"
      );

      if (response?.success) {
        toast.success("OTP Verified");
        setOtp("");  
        setShowOtpPopup(false);

        createBooking();
      } else {
        toast.error(response?.message || "Invalid OTP");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoader(false);
    }
  };
  console.log(locationId, "locationId");

  const createBooking = async () => {
    try {
      let values = { ...modelData };
      values.step = "createBooking";
      values.userId = userId;
      values.locationId = locationId;

      const response = await apicall.post(values, "create_customer_booking");
console.log(response,"response")
      if (response?.success) {
        // Show custom success message
        toast.success("Booking Done");
        window.location.reload();

        // Save booking_id in state
        values.booking_id = response?.booking_id || 1;
        setModelData(values);
        setShowOrderConf(true);
       
      } else {
        // Optional: show error toast if backend returns success: false
        toast.error(response?.message || "Booking failed");
      }
    } catch (e) {
      console.log(e);
    }
  };
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      // setLoading(true);   // button loader

      let flag = true;
      let addedService = serviceData?.filter((ele) => ele?.added);

if (!services || services.length === 0) {
  toast.error("Please add Service Type and Offerings from Admin Setup before booking.");
  setSubmitting(false); // important
  return;
}

if (!serviceTypes || serviceTypes.length === 0) {
  toast.error("Please configure Service Offerings before proceeding.");
  setSubmitting(false);
  return;
}

if (addedService?.length === 0) {
  toast.error("Select Service Offerings to proceed");
  setSubmitting(false);
  return;
}

if (!timeSelect) {
  toast.error("Select Time");
  setSubmitting(false);
  return;
}
      if (!flag) return;

      let d1 = {
        house_no: values?.house_no || "",
        area: values?.area || "",
        location: values?.location || "",
        state: values?.state || "",
        landmark: values?.landmark || "",
        lat: values?.lat || "",
        lng: values?.lng || "",
      };

      let isLocationChanged = false;

      if (JSON.stringify(d1) !== JSON.stringify(firstLocation)) {
        isLocationChanged = true;
      }

      let providers = providerSelected?.map(
        (ele) => ele?.extendedProps?.provider_id
      );

      values.editable = editable ? 1 : 0;
      values.date = dateSelect;
      values.isLocationChanged = isLocationChanged;
      values.time = timeSelect;
      values.serviceData = serviceData;
      values.priceSection = priceSection;
      values.providers = providers?.join(", ");
      values.group_id = group_id;
      values.vendor_id = vendor_id;

      setModelData(values);

      const response = await apicall.post(
        { ...values, step: "createCustomer" },
        "create_customer_booking"
      );
      console.log(response, "response");
      if (response?.success) {
        toast.success("OTP sent to customer mobile");

        setUserId(response.userId);
        setLocationId(response.location_id);
        setOTPresult(response);

        setShowOtpPopup(true);
      }
      setSubmitting(false);
    } catch (e) {
      console.log(e);
    }
  };

  const addOffering = (data) => {
    try {
      // console.log("data-----", data);
      let t1 = data?.time_required + data?.buffer;

      if (t1 > maxTime) {
        setMaxTime(t1);
      }
      let { service_offering_id } = data;
      let copyServiceData = JSON.parse(JSON.stringify(serviceData));
      for (let eachdata of copyServiceData) {
        if (eachdata?.service_offering_id === service_offering_id) {
          eachdata.added = !eachdata.added;
          break;
        }
      }
      setServiceData(copyServiceData);
    } catch (e) {
      console.log("err----", e);
    }
  };

  function priceChange(value, data) {
    try {
      let copyServiceData = JSON.parse(JSON.stringify(serviceData));

      for (let eachData of copyServiceData) {
        if (eachData.service_offering_id === data?.service_offering_id) {
          eachData.amount = value;
        }
      }
      if (data?.name === "Discount") {
        setDiscount(value);
      }

      setServiceData(copyServiceData);
    } catch (e) {
      console.log("err-----", e);
    }
  }

  const onHide = () => {
    setShowCalender(false);
    flagCount.current = 0;
  };

  // console.log("modelData---", modelData);

  function convertWithoutTimseStamp(date) {
    try {
      const year = date?.getFullYear();
      const month = String(date?.getMonth() + 1).padStart(2, "0");
      const day = String(date?.getDate()).padStart(2, "0");
      const hours = String(date?.getHours()).padStart(2, "0");
      const minutes = String(date?.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day}T${hours}:${minutes}:00`;
    } catch (e) {
      console.log("err---", date, e);
    }
  }

  const handleAppointmentClick = (appointment, currentDate) => {
    console.log(
      "data---handleAppointmentClick---",
      appointment,
      currentDate,
      filteredAppointments
    );
    // console.log("data---filteredAppointments---", appointment?.details?.start);
    let copyFilterData = JSON.parse(JSON.stringify(filteredAppointments));
    let alreadyBookedSlots = copyFilterData.filter((ele) => ele.status === 3);
    // ?.map((ele) => ele.start);

    console.log("alreadyBookedSlots-------", alreadyBookedSlots);

    setDateSelect(appointment?.details?.start?.split("T")?.[0]);
    let agentAssigned = [];

    if (appointment?.details?.status !== 3) {
      copyFilterData?.forEach((eachdata, idx) => {
        if ([3, 6].includes(eachdata?.status)) {
          // continue;
        } else if (appointment?.details?.start !== eachdata.start) {
          eachdata.status = 1;
          let date = new Date(eachdata?.start);
          date.setMinutes(date.getMinutes() + 30);
          eachdata.end = date;
        } else if (
          eachdata?.extendedProps?.provider_id ===
            appointment?.details?.extendedProps?.provider_id &&
          eachdata?.start === appointment?.details?.start &&
          eachdata.status === 2
        ) {
          console.log("not there.......");
          eachdata.status = 1;
          let date = new Date(eachdata?.start);
          date.setMinutes(date.getMinutes() + 30);
          eachdata.end = date;
        } else if (
          eachdata?.extendedProps?.provider_id ===
            appointment?.details?.extendedProps?.provider_id &&
          eachdata?.start === appointment?.details?.start &&
          eachdata.status === 1
        ) {
          // eachdata.status = 2;

          let flag = true;
          for (let i of alreadyBookedSlots) {
            let s1 = new Date(eachdata?.start);
            s1.setMinutes(s1.getMinutes() + maxTime);

            let e1 = new Date(i?.start);
            let e2 = new Date(i?.end);
            console.log("s1,e1,e2------", s1, e1, e2);
            if (
              s1 >= e1 &&
              s1 <= e2 &&
              i?.extendedProps?.provider_id ===
                eachdata?.extendedProps?.provider_id
            ) {
              flag = false;
              console.log("done........");
              break;
            }
          }
          if (flag) eachdata.status = 2;
        }

        if (eachdata?.status === 2) {
          let date = new Date(eachdata?.start);
          date.setMinutes(date.getMinutes() + maxTime);
          eachdata.end = date;

          eachdata.end = convertWithoutTimseStamp(date);

          // console.log("eachData--", eachdata, maxTime);
          agentAssigned.push(eachdata);
        }
      });
    }

    let initial1 = JSON.parse(JSON.stringify(initialAppointments));
    // console.log("before intital----", initialAppointments, initial1);
    // console.log("inti-", initial1, copyFilterData);

    for (let x = 0; x < initialAppointments.length; x++) {
      let i = initial1[x];

      for (let j of copyFilterData) {
        if (
          j.status === 2 &&
          i.start === j.start &&
          i.extendedProps?.provider_id === j.extendedProps?.provider_id
        ) {
          initial1[x] = JSON.parse(JSON.stringify(j)); // <-- correctly updates array
          break;
        }
      }
    }

    // console.log("after intital----", initial1);

    setProviderSelected(agentAssigned);

    let updated = [];

    for (let i of initial1) {
      let flag = true;
      if ([2, 3].includes(i.status)) {
        updated?.push(i);
      } else {
        for (let j of agentAssigned) {
          let s1 = convertWithoutTimseStamp(new Date(i.start));
          let e1 = convertWithoutTimseStamp(new Date(i.end));
          let p1 = i.extendedProps?.provider_id;
          let s2 = convertWithoutTimseStamp(new Date(j.start));
          let e2 = convertWithoutTimseStamp(new Date(j.end));
          let p2 = j.extendedProps?.provider_id;
          if (p1 === p2 && s1 >= s2 && e1 <= e2) {
            flag = false;
            break;
          }
        }
        if (flag) {
          if (editable) {
            updated?.push(i);
          } else {
            let hours = timeSelect.split(":")[0];
            let mins = timeSelect.split(":")[1];

            let res = i.start.split("T")[1];
            console.log(
              "res--",
              res,
              `${hours}:${mins}:00`,
              res === `${hours}:${mins}:00`
            );
            if (res === `${hours}:${mins}:00`) {
              updated?.push(i);
            }
          }
        }
      }
    }
    // console.log("updated--", updated);

    setFilteredAppointments(updated);
  };

  const datesSet = (dateInfo) => {
    try {
      let d1 = dateInfo.startStr?.split("T")?.[0];

      getWorkerAvailableSlots(d1);

      if (![0, 1].includes(flagCount.current)) {
        // console.log("adteIfo---", dateInfo);
      }
      flagCount.current += 1;
    } catch (e) {
      console.log("err---", e);
    }
  };

  // console.log("dateSelect-----", dateSelect);

  const getWorkerAvailableSlots = async (selecDate) => {
    try {
      // console.log("selecDate----", selecDate);
      let d1 = new Date(selecDate);
      d1 = d1.toLocaleDateString("en-GB").split(/[\/\-\.]/);
      d1 = `${d1[2]}-${d1[1]}-${d1[0]}`;
      // console.log("d1---", d1);
      // setDateSelect(d1);
      setLoading(true);
      let q1 = `getWokerAvailableSlots?date=${d1}`;

      // console.log("selectedService---", selectedService);
      if (
        selectedService?.service_id &&
        selectedService?.service_id !== "undefined"
      ) {
        q1 += `&&service_id=${selectedService?.service_id}`;
      }
      let getWorkerAvailable = await apicall.get(q1);

      let updatedData =
        JSON.parse(JSON.stringify(getWorkerAvailable?.data)) || [];

      // console.log("1st.......", getWorkerAvailable?.data);

      setInitialAppointments(getWorkerAvailable?.data || []);

      for (let i of providerSelected) {
        for (let j of updatedData) {
          if (
            i?.start === j?.start &&
            i.extendedProps.provider_id === j.extendedProps.provider_id
          ) {
            j.status = 2;
            let date = new Date(j?.start);
            date.setMinutes(date.getMinutes() + maxTime);
            j.end = date;
          }
        }
      }

      let updated = [];

      for (let i of updatedData) {
        let flag = true;
        if ([2, 3].includes(i.status)) {
          updated?.push(i);
        } else {
          for (let j of providerSelected) {
            let s1 = new Date(i.start);
            let e1 = new Date(i.end);
            let p1 = i.extendedProps?.provider_id;

            let s2 = new Date(j.start);
            let e2 = new Date(j.end);
            let p2 = j.extendedProps?.provider_id;

            if (p1 === p2 && s1 >= s2 && e1 <= e2) {
              flag = false;
              break;
            }
          }
          if (flag) {
            if (editable) {
              updated?.push(i);
            } else {
              let hours = timeSelect.split(":")[0];
              let mins = timeSelect.split(":")[1];

              let res = i.start.split("T")[1];
              // console.log(
              //   "res--",
              //   res,
              //   `${hours}:${mins}:00`,
              //   res === `${hours}:${mins}:00`
              // );
              if (res === `${hours}:${mins}:00`) {
                updated?.push(i);
              }
            }
          }
        }
      }

      // console.log("2nd-------", getWorkerAvailable?.data);

      for (let i of updated) {
        if (i.status === 2) {
          let date = new Date(i?.start);
          let t1 = maxTime / crewCount;
          date.setMinutes(date.getMinutes() + t1);
          i.end = convertWithoutTimseStamp(date);
        }
      }

      let u1 = cleanCrewSlots(updated);

      const result = u1.reduce(
        (acc, item) => {
          return {
            minStart: item.start < acc.minStart ? item.start : acc.minStart,
            maxEnd: item.end > acc.maxEnd ? item.end : acc.maxEnd,
          };
        },
        {
          minStart: u1[0].start,
          maxEnd: u1[0].end,
        }
      );
      let min1 = result?.minStart?.split("T")[1];
      let max1 = result?.maxEnd?.split("T")[1];
      setTimeRange({ startTime: min1, endTime: max1 });

      setFilteredAppointments(u1 || []);
      setShowCalender(true);
      close();
    } catch (e) {
      console.log("err--", e);
    }
  };

const generateTimeSlots = (startHour, endHour, interval) => {
  const slots = [];
  let start = new Date();
  start.setHours(startHour, 0, 0, 0);

  const end = new Date();
  end.setHours(endHour, 0, 0, 0);

  while (start <= end) {
    let hours = start.getHours();
    let minutes = start.getMinutes();

    const ampm = hours >= 12 ? "PM" : "AM";

    // Convert to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 becomes 12

    const formattedHours = hours.toString().padStart(2, "0");
    const formattedMinutes = minutes.toString().padStart(2, "0");

    slots.push(`${formattedHours}:${formattedMinutes} ${ampm}`);

    start.setMinutes(start.getMinutes() + interval);
  }

  return slots;
};

const timeSlots = generateTimeSlots(8, 17, 60);

  const convertTo12Hour = (time) => {
    if (!time) return "";

    const [hour, minute] = time.split(":");
    const h = parseInt(hour);

    const ampm = h >= 12 ? "PM" : "AM";
    const formattedHour = h % 12 || 12;

    return `${formattedHour}:${minute} ${ampm}`;
  };
  const onHideOrderConf = () => {
    setShowOrderConf(false);
    navigate("/dashboard");
  };

  if (loading && isEditing) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "400px" }}
      >
        <Spinner animation="border" variant="danger" />
      </div>
    );
  }
  const formatDateDisplay = (date) => {
    if (!date) return "";

    return new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  function close() {
    setOpen(false);
  }

  return (
    <>
      <RotateDevicePopup />

      <div className="booking-bg">
        <div className="container py-3">
<div className="d-flex align-items-center justify-content-between mb-4">
  
  {/* LEFT: Heading */}
  <h2 className="fw-bold m-0">
    {`Book a Service with ${vendorDetails?.first_name ? vendorDetails?.first_name :vendorDetails?.fullName}`}
  </h2>

  {/* RIGHT: Profile Image */}
  {vendorDetails?.profile_image && (
    <img
      src={vendorDetails.profile_image}
      alt="profile"
      style={{
        width: "70px",
        height: "70px",
        borderRadius: "50%",
        objectFit: "cover",
        border: "2px solid #eee",
      }}
    />
  )}

</div>
          <div className="row align-items-start">
            {vendorDetails?.image && (
  <div
    className="col-md-4"
    style={{
      marginBottom: window.innerWidth < 768 ? "30px" : "0px",
    }}
  >
    <div style={{ width: "100%", height: "500px" }}>
      <img
        src={vendorDetails?.image}
        alt="Profile"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "12px",
          marginTop: "20px",
        }}
      />
    </div>
  </div>
)}
            <div className={vendorDetails?.image ? "col-md-8 " : "col-md-12"}>
              <div onClick={close}>
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                  enableReinitialize={true}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                    setValues,
                    setFieldError,
                    setFieldTouched,
                  }) => (
                    <Form
                      onSubmit={
                        handleSubmit
                        //     (e) => {
                        //     e.preventDefault();
                        //     setPendingValues(values);
                        //     sendOtp(values.mobileNumber);
                        //   }
                      }
                    >
                      <div className="mt-4 mb-2">
                        <Accordion activeKey={activeAccordion} alwaysOpen>
                          <Accordion.Item eventKey="0">
                            <Accordion.Header
                              onClick={() => handleToggleAccordion("0")}
                            >
                              Service Information
                            </Accordion.Header>
                            <Accordion.Body>
                              {/* ================= CARD 1 ================= */}
                              {/* SERVICE TYPE + OFFERING */}
                              <div className="service-selection-card mb-4">
                                {/* SERVICE TYPE */}
                             <div className="mb-4">
                            <h6 className="section-title">
                              Service Category
                              <span style={{ color: "red", fontSize: "1rem" }}>
                                *
                              </span>
                            </h6>

                            {services && services.length > 0 ? (
                              <div className="d-flex gap-3 flex-wrap">
                                {services.map((ele) => (
                                  <div
                                    key={ele.service_id}
                                    onClick={() => setSelectedService(ele)}
                                    className={`service-type-pill ${
                                      ele?.service_id ===
                                      selectedService?.service_id
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    {ele?.service_name}
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div className="text-center p-4 border rounded bg-light">
                                <h6 className="text-danger mb-2">
                                  No Services Available
                                </h6>
                                <p className="text-muted mb-0">
                                  Please add Service & Type from Admin Setup to
                                  continue booking.
                                </p>
                              </div>
                            )}
                          </div>
                          {/* SERVICE TYPE */}
                          {!Object.keys(groupedData).includes("null") && (
                            <div className="mb-4">
                              <h6 className="section-title">
                                Sub Category
                                <span
                                  style={{ color: "red", fontSize: "1rem" }}
                                >
                                  *
                                </span>
                              </h6>

                              <div className="d-flex gap-3 flex-wrap">
                                {Object.keys(groupedData).map((ele) => (
                                  <div
                                    key={ele}
                                    onClick={() => setActiveType(ele)}
                                    className={`service-type-pill ${
                                      ele === activeType ? "active" : ""
                                    }`}
                                  >
                                    {ele}
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}

                          {/* SELECT OFFERING */}
                          {services?.length > 0 && (
                            <>
                              {serviceTypes && serviceTypes.length > 0 ? (
                                <div>
                                  <h6 className="section-title">
                                    Service Type
                                    <span
                                      style={{ color: "red", fontSize: "1rem" }}
                                    >
                                      *
                                    </span>
                                  </h6>

                                  <div className="row g-3">
                                    {groupedData?.[activeType]?.map((data) => (
                                      <div className="col-md-3" key={data.id}>
                                        <div
                                          onClick={() => addOffering(data)}
                                          className="offering-row-card d-flex justify-content-between align-items-center"
                                        >
                                          <div>
                                            <div className="fw-semibold">
                                              {data?.service_offering_name}
                                            </div>
                                            <div className="price-text">
                                              {currency} {data?.price}
                                            </div>
                                          </div>

                                          <div
                                            className={`btn btn-sm rounded-3 ${
                                              data?.added
                                                ? "btn-danger"
                                                : "btn-outline-danger"
                                            }`}
                                          >
                                            {data?.added ? "Added" : "Add"}
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              ) : (
                                <div className="text-center p-4 border rounded bg-light">
                                  <h6 className="text-danger mb-2">
                                    No Service Types Available
                                  </h6>
                                  <p className="text-muted mb-0">
                                    Please add Service Type under the selected
                                    Service to continue booking.
                                  </p>
                                </div>
                              )}
                            </>
                          )}
                        </div>

                              {/* ================= CARD 2 ================= */}
                              {/* SERVICE INFORMATION */}
                              <div className="service-summary-card">
                                <div className="p-3">
                                  {/* DATE + TIME + CREW + STATUS + PAYMENT */}
                                  {/* Start Date */}
                                  <Row>
                                    <Col
                                      md={3}
                                      style={{ marginBottom: "1%" }}
                                      // onClick={(e) => e.stopPropagation()}
                                    >
                                      <div className="d-flex  flex-column">
                                        <Form.Label>Select Date
                                           <span style={{ color: "red" }}>*</span>
                                        </Form.Label>
                                         <div className="position-relative" ref={wrapperRef}>
      <button
        type="button"
        className="btn d-flex align-items-center gap-2 px-3 position-relative"
        style={{
          height: "40px",
          fontSize: "14px",
          borderRadius: "6px",
          backgroundColor: "#FFFFFF",
          border: "1px solid #E3EBF8",
          color: "#000000",
          justifyContent: "space-between",
          width: "100%",
        }}
        onClick={(e) => {
          e.stopPropagation(); // ✅ prevent outside click trigger
          setOpen((prev) => !prev); // toggle
        }}
      >
        {formatDateDisplay(dateSelect)}
        <FaRegCalendarAlt className="position-absolute end-0 mx-2" />
      </button>

      {open && (
        <div
          onClick={(e) => e.stopPropagation()} // ✅ prevent closing when clicking inside
          style={{
            position: "absolute",
            top: "100%",
            left: "0",
            zIndex: 9999,
            backgroundColor: "#fff",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            borderRadius: "8px",
            marginTop: "5px",
          }}
        >
          <DatePicker
            inline
            selected={dateSelect}
            onChange={(date) => {
              setDateSelect(date);
              setOpen(false); // ✅ close after select
            }}
            dateFormat="dd-MM-yyyy"
          />
        </div>
      )}
    </div>
                                      </div>
                                    </Col>

                                    {/* Selected Time */}
                                    {/* <Col md={9}>
  <div className="d-flex flex-column">
    <Form.Label>Select Time</Form.Label>

    <div className="d-flex flex-wrap gap-2">
      {timeSlots.map((time, index) => (
        <button
          key={index}
          type="button"
          className={`btn btn-sm ${
            timeSelect === time ? "btn-danger" : "btn-outline-danger"
          }`}
          onClick={() => setTimeSelect(time)}
        >
          {convertTo12Hour(time)}
        </button>
      ))}
    </div>
  </div>
</Col> */}
                                    <Col md={3}>
                                      <div className="d-flex flex-column">
                                        <Form.Label>Select Time
                                           <span style={{ color: "red" }}>*</span>
                                        </Form.Label>

                                        <Form.Select
                                          value={timeSelect || ""}
                                          onChange={(e) =>
                                            setTimeSelect(e.target.value)
                                          }
                                          style={{ height: "40px" }}
                                        >
                                          <option value="">Select Time</option>

                                          {timeSlots.map((time, index) => (
                                            <option key={index} value={time}>
                                              {time}
                                            </option>
                                          ))}
                                        </Form.Select>
                                      </div>
                                    </Col>
                                    <Col md={3}>
                                      <Button onClick={openAccordion1}>
                                        Next
                                      </Button>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="1">
                            <Accordion.Header
                              onClick={() => handleToggleAccordion("1")}
                            >
                              Customer Information
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="mb-4">
                                {/* <h6 className="mb-4 section-heading">Personal Details</h6> */}
                                <Row className="mb-4">
                                  <Col md={4}>
                                    <Form.Group>
                                      <Form.Label>Customer Name
                                         <span style={{ color: "red" }}>*</span>
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="userName"
                                        placeholder="Enter Customer Name..."
                                        value={values.userName}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        disabled={!editable}
                                        isInvalid={
                                          touched.userName && errors.userName
                                        }
                                        className="form-input"
                                      />
                                      {touched.userName && errors.userName && (
                                        <Form.Control.Feedback type="invalid">
                                          {errors.userName}
                                        </Form.Control.Feedback>
                                      )}
                                    </Form.Group>
                                  </Col>
                                  <Col md={4}>
                              <Form.Group>
                                <Form.Label>
                                  Mobile Number
                                  <span style={{ color: "red" }}>*</span>
                                </Form.Label>
                                <PhoneInput
                                  country={currency === "INR" ? "in" : "ae"}
                                  // country={phoneCountryCode}
                                  onlyCountries={["ae", "in"]}
                                  value={values.mobileNumber}
                                  disabled={!editable}
                                  onChange={(value) => {
                                    const cleanedValue = value.replace(
                                      /\D/g,
                                      ""
                                    );
                                    setFieldValue("mobileNumber", cleanedValue);
                                    setFieldTouched("mobileNumber", true, false);

                                    // Only check for user existence if the number is valid
                                    if (cleanedValue.length >= 12) {
                                      debouncedCheckUserExists(
                                        "mobileNumber",
                                        cleanedValue,
                                        setFieldValue,
                                        setFieldError
                                      );
                                    }
                                  }}
                                  inputStyle={{
                                    width: "100%",
                                    height: "40px",
                                    backgroundColor: "white",
                                    borderColor:
                                      touched.mobileNumber && errors.mobileNumber
                                        ? "#dc3545"
                                        : "#E9ECEF",
                                  }}
                                  inputProps={{
                                    name: "mobileNumber",
                                    // required: true,
                                  }}
                                />
                                {touched.mobileNumber && errors.mobileNumber && (
                                  <div className="invalid-feedback d-block">
                                    {errors.mobileNumber}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                                  <Col md={4}>
                                    <Form.Group>
                                      <Form.Label>Email Address</Form.Label>
                                      <Form.Control
                                        type="email"
                                        name="email"
                                        placeholder="Enter email address"
                                        value={values.email}
                                        disabled={!editable}
                                        onChange={(e) => {
                                          handleChange(e);
                                          const value = e.target.value;
                                          setFieldTouched("email", true, false);
                                          if (
                                            !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                                              value
                                            )
                                          ) {
                                            setFieldError(
                                              "email",
                                              "Invalid email format"
                                            );
                                          }
                                        }}
                                        onBlur={handleBlur}
                                        isInvalid={
                                          touched.email && errors.email
                                        }
                                        className="form-input"
                                      />
                                      {touched.email && errors.email && (
                                        <Form.Control.Feedback type="invalid">
                                          {errors.email}
                                        </Form.Control.Feedback>
                                      )}
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </div>
                              <div className="mb-4">
                                <h6 className="section-heading">Address</h6>
                                <Row className="g-3">
                                  <Col md={4}>
  <Form.Group>
    <Form.Label>
      Address    <span style={{ color: "red" }}>*</span>
    </Form.Label>

    <div style={{ position: "relative" }}>
      {isLoaded && (
        <Autocomplete
          onLoad={onLoad}
          onPlaceChanged={() => onPlaceChanged(setFieldValue)}
          options={{
    componentRestrictions: {
      country: currency === "INR" ? "in" : "ae", 
    },
  }}
        >
          <Form.Control
            type="text"
            name="location"
            placeholder="Search address"
            value={values.location}
            onChange={handleChange}
            className="form-input"
          />
        </Autocomplete>
      )}

      {values.location && (
        <span
          onClick={() => {
            setFieldValue("location","");
            setFieldValue("area", "");
            setFieldValue("state", "");
            setFieldValue("lat", "");
            setFieldValue("lng", "");
          }}
          style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
          }}
        >
          ✖
        </span>
      )}
      {locationError && (
  <div className="text-danger mt-1" style={{ fontSize: "13px" }}>
    {locationError}
  </div>
)}
    </div>
  </Form.Group>
</Col>
<Col md={4}>
  <Form.Group>
    <Form.Label>
      House / Flat / Building No
      <span style={{ color: "red" }}>*</span>
    </Form.Label>

    <Form.Control
      type="text"
      name="house_no"
      placeholder="Enter house / flat / building no"
      value={values.house_no}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={!editable}
      isInvalid={touched.house_no && errors.house_no}
      className="form-input"
      style={{ height: "40px" }}
    />

    {touched.house_no && errors.house_no && (
      <div className="invalid-feedback d-block">
        {errors.house_no}
      </div>
    )}
  </Form.Group>
</Col>
                                  <Col md={4}>
                                    <Form.Group>
                                      <Form.Label>Area
                                         <span style={{ color: "red" }}>*</span>
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="area"
                                        placeholder="Enter area details..."
                                        value={values.area}
                                        onChange={handleChange}
                                        disabled={!editable}
                                        onBlur={handleBlur}
                                        isInvalid={touched.area && errors.area}
                                        className="form-input"
                                        style={{ height: "40px" }}
                                      />
                                      {touched.area && errors.area && (
                                        <div className="invalid-feedback d-block">
                                          {errors.area}
                                        </div>
                                      )}
                                    </Form.Group>
                                  </Col>
                                  {/* <Col md={4}>
                                    <Form.Group>
                                      <Form.Label>Location
                                         <span style={{ color: "red" }}>*</span>
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="location"
                                        placeholder="Enter location details..."
                                        value={values.location}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        disabled={!editable}
                                        isInvalid={
                                          touched.location && errors.location
                                        }
                                        className="form-input"
                                        style={{ height: "40px" }}
                                      />
                                      {touched.location && errors.location && (
                                        <div className="invalid-feedback d-block">
                                          {errors.location}
                                        </div>
                                      )}
                                    </Form.Group>
                                  </Col> */}

                               <Col md={4}>
                                                         <Form.Group>
                                                           <Form.Label>
                                                             {currency === "INR" ? "State" : "Emirate"}
                                                             <span
                                                               style={{ color: "red", fontSize: "1rem" }}
                                                             >
                                                               *
                                                             </span>
                                                           </Form.Label>
                                                           {/* <Form.Select
                                                         name="state"
                                                         value={values.state}
                                                         onChange={(e) =>
                                                           handleStateChange(e, setFieldValue)
                                                         }
                                                         onBlur={handleBlur}
                                                         isInvalid={touched.state && errors.state}
                                                         className={`form-input ${
                                                           values.state === "" ? "placeholder-style" : ""
                                                         }`}
                                                         style={{
                                                           height: "40px",
                                                           backgroundColor: "white",
                                                           border:
                                                             touched.state && errors.state
                                                               ? "1px solid #dc3545"
                                                               : "1px solid #E9ECEF",
                                                         }}
                                                       >
                                                         <option value="">Select Emirate</option>
                                                         {states.map((state) => (
                                                           <option key={state.name} value={state.name}>
                                                             {state.name}
                                                           </option>
                                                         ))}
                                                       </Form.Select> */}
                                                           <Dropdown
                                                             name="state"
                                                             value={values.state}
                                                             options={states?.map((s) => ({
                                                               label: s.name,
                                                               value: s.name,
                                                             }))}
                                                             placeholder={
                                                               currency === "INR"
                                                                 ? "Select State"
                                                                 : "Select Emirate"
                                                             }
                                                             disabled={!editable}
                                                             onChange={(e) => {
                                                               // console.log("Selected Emirate:", e.value);
                           
                                                               handleStateChange(e, setFieldValue); // your existing function
                                                               setFieldValue("state", e.value);
                                                             }}
                                                             onBlur={handleBlur}
                                                             className={`w-100 ${
                                                               touched.state && errors.state
                                                                 ? "is-invalid"
                                                                 : ""
                                                             }`}
                                                             style={{
                                                               height: "40px",
                                                               backgroundColor: "white",
                                                               border:
                                                                 touched.state && errors.state
                                                                   ? "1px solid #dc3545"
                                                                   : "1px solid #E9ECEF",
                                                             }}
                                                           />
                           
                                                           {touched.state && errors.state && (
                                                             <div className="invalid-feedback d-block">
                                                               {errors.state}
                                                             </div>
                                                           )}
                                                         </Form.Group>
                                                       </Col>

                                  <Col md={4}>
                                    <Form.Group>
                                      <Form.Label>Landmark</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="landmark"
                                        placeholder="Enter landmark details..."
                                        value={values.landmark}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        disabled={!editable}
                                        isInvalid={
                                          touched.landmark && errors.landmark
                                        }
                                        className="form-input"
                                        style={{ height: "40px" }}
                                      />
                                      {touched.landmark && errors.landmark && (
                                        <div className="invalid-feedback d-block">
                                          {errors.landmark}
                                        </div>
                                      )}
                                    </Form.Group>
                                  </Col>

                                   <Col md={4}>
                                                            <Form.Group>
                                                              <Form.Label>Country</Form.Label>
                                                              <Dropdown
                                                                name="country"
                                                                value={currency === "INR" ? 2 : 1}
                                                                options={countries?.map((c) => ({
                                                                  label: c.name,
                                                                  value: Number(c.country_id),
                                                                }))}
                                                                placeholder="Select Country"
                                                                disabled={!editable}
                                                                onChange={(e) => {
                                                                  // console.log("Selected Country:", e.value);
                              
                                                                  handleCountryChange(e, setFieldValue); // your existing function
                                                                  setFieldValue("country", e.value);
                                                                }}
                                                                onBlur={handleBlur}
                                                                className={`w-100 ${
                                                                  touched.country && errors.country
                                                                    ? "is-invalid"
                                                                    : ""
                                                                }`}
                                                                style={{
                                                                  height: "40px",
                                                                  backgroundColor: "white",
                                                                  border:
                                                                    touched.country && errors.country
                                                                      ? "1px solid #dc3545"
                                                                      : "1px solid #E9ECEF",
                                                                }}
                                                              />
                                                              {touched.country && errors.country && (
                                                                <div className="invalid-feedback d-block">
                                                                  Please select a country
                                                                </div>
                                                              )}
                                                            </Form.Group>
                                                          </Col>
                                  {/* <Col md={4}>
                          <Form.Group>
                            <Form.Label>City</Form.Label>
                            <Form.Select
                              name="city"
                              value={values.city}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={touched.city && errors.city}
                              className={`form-input ${
                                values.city === "" ? "placeholder-style" : ""
                              }`}
                              style={{
                                height: "40px",
                                backgroundColor: "white",
                                border:
                                  touched.city && errors.city
                                    ? "1px solid #dc3545"
                                    : "1px solid #E9ECEF",
                              }}
                            >
                              <option value="">Select City</option>
                              {cities.map((city) => (
                                <option key={city.city_id} value={city.city_id}>
                                  {city.name}
                                </option>
                              ))}
                            </Form.Select>
                            {touched.city && errors.city && (
                              <div className="invalid-feedback d-block">
                                {errors.city}
                              </div>
                            )}
                          </Form.Group>
                        </Col> */}
                                  <Col md={4}>
                                    <Form.Group>
                                      <Form.Label>
                                        Longitude and Latitude
                                      </Form.Label>
                                      <Row className="g-2">
                                        <Col>
                                          <Form.Control
                                            type="text"
                                            name="lat"
                                            placeholder="Latitude"
                                            value={values.lat}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            disabled={!editable}
                                            isInvalid={
                                              touched.lat && errors.lat
                                            }
                                            className="form-input"
                                            style={{
                                              fontSize: "14px",
                                              height: "40px",
                                            }}
                                          />
                                          {touched.lat && errors.lat && (
                                            <div className="invalid-feedback d-block">
                                              {errors.lat}
                                            </div>
                                          )}
                                        </Col>
                                        <Col>
                                          <Form.Control
                                            type="text"
                                            name="lng"
                                            placeholder="Longitude"
                                            value={values.lng}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            disabled={!editable}
                                            isInvalid={
                                              touched.lng && errors.lng
                                            }
                                            className="form-input"
                                            style={{
                                              fontSize: "14px",
                                              height: "40px",
                                            }}
                                          />
                                          {touched.lng && errors.lng && (
                                            <div className="invalid-feedback d-block">
                                              {errors.lng}
                                            </div>
                                          )}
                                        </Col>
                                      </Row>
                                    </Form.Group>
                                  </Col>
                                </Row>
                                   <div
                                                              className="border rounded"
                                                              style={{ marginTop: "10px" }}
                                                            >
                                                              {/* Header */}
                                                              <div className="d-flex justify-content-between align-items-center fw-semibold px-3 py-2 bg-light border-bottom">
                                                                <div className="d-flex align-items-center gap-3">
                                                                  <span>Service</span>
                                
                                                                 
                                                                </div>
                                
                                                                <span>Price ({currency})</span>
                                                              </div>
                                
                                                              {/* Service Rows */}
                                                              {priceSection?.map((data, idx) => {
                                                                const isLabelField =
                                                                  data?.name?.toLowerCase().includes("tax") ||
                                                                  data?.name?.toLowerCase().includes("total");
                                 data?.name?.toLowerCase().includes("discount");
                                                                return (
                                                                  <div
                                                                    key={data.id || data.name}
                                                                    className={`d-flex justify-content-between align-items-center px-3 py-2 border-bottom ${
                                                                      isLabelField ? "bg-light fw-semibold" : ""
                                                                    }`}
                                                                  >
                                                                    <span>{data?.name}</span>
  <span className="text-muted">
                                                                        {currency} {data?.amount}
                                                                      </span>
                                                                    {/* {isLabelField ? (
                                                                      <span className="text-muted">
                                                                        {currency} {data?.amount}
                                                                      </span>
                                                                    ) : (
                                                                      <div className="d-flex align-items-center gap-2">
                                                                        <span className="text-muted">
                                                                          {currency}
                                                                        </span>
                                
                                                                        <Form.Control
                                                                          type="number"
                                                                          value={data?.amount}
                                                                          size="sm"
                                                                          style={{ width: "100px" }}
                                                                          onChange={(e) => {
                                                                           priceChange(e.target.value, data);
                                                                          }}
                                                                        />
                                                                       
                                                                      </div>
                                                                    )} */}
                                                                  </div>
                                                                );
                                                              })}
                                                            </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </div>

                      <div className="d-flex justify-content-center mb-0 gap-4">
                        {/* <Button
                variant="light"
                // onClick={handleNavigation}
                className="custom-btn btn-large"
              >
                Cancel
              </Button> */}
                        <Button
                          type="submit"
                          variant="danger"
                          disabled={isSubmitting}
                          className="custom-btn btn-large"
                        >
                          Submit
                          {/* {loading ? <Loader/> : "Submit" }  */}
                        </Button>
                      </div>
                    </Form>
                  )}
                </Formik>
                {showOtpPopup && (
                  <>
                    <div className="otp-popup-overlay">
                      <div
      className="otp-popup-card position-relative"
      style={{ paddingTop: "20px" }}
    >
      <span
        onClick={() => setShowOtpPopup(false)}
        style={{
          position: "absolute",
          top: "10px",
          right: "15px",
          fontSize: "18px",
          cursor: "pointer",
          fontWeight: "bold",
        }}
      >
        ✕
      </span>
                        <div className="greyColor">
                          Enter the code we just sent on your phone
                        </div>
                        <div className="d-flex justify-content-center">
                          <OtpInput
                            value={otp}
                            onChange={setOtp}
                            numInputs={6}
                            renderSeparator={<span>&nbsp;&nbsp;</span>}
                            renderInput={renderOtpInput}
                            containerStyle={{
                              width: "70%",
                              height: "100px",
                              alignItems: "center",
                            }}
                            inputStyle={{ width: "40%", height: "50%" }}
                          />
                        </div>
                        {errorMessages && (
                          <div className="label text-danger text-center">
                            {errorMessages}
                          </div>
                        )}
                        <div className="text-center">
                          <button
                            style={{ marginLeft: "40%" }}
                            className="btn btn-block primaryBackground text-white"
                            onClick={verifyOtp}
                            disabled={loader || otp.length !== 6}
                          >
                            VerifyOtp
                          </button>
                        </div>
                      </div>
                    </div>
                  </>

                  //   <div className="otp-popup-overlay">
                  //     <div className="otp-popup-card">
                  //       <h5>Enter OTP</h5>

                  //       <OTPInput
                  //         value={otp}
                  //         onChange={setOtp}
                  //         numInputs={6}
                  //         renderSeparator={<span>-</span>}
                  //         renderInput={(props) => <input {...props} />}
                  //       />

                  //       <div className="mt-3 d-flex gap-2 justify-content-center">
                  //         <button
                  //           className="btn btn-secondary"
                  //           onClick={() => setShowOtpPopup(false)}
                  //         >
                  //           Cancel
                  //         </button>

                  //         <button
                  //           className="btn btn-danger"
                  //           onClick={verifyOtp}
                  //         >
                  //           Verify OTP
                  //         </button>
                  //       </div>
                  //     </div>
                  //   </div>
                )}
              </div>
            </div>

<div className="company-footer mt-4">
  {/* {vendorDetails?.address && (
    <div className="footer-item">
      <span className="footer-icon">
        <FaMapMarkerAlt />
      </span>
      <div>{vendorDetails.address}</div>
    </div>
  )} */}
    {(vendorDetails?.city_name || vendorDetails?.vendor_state || vendorDetails?.State || vendorDetails?.vendor_country || vendorDetails?.Country) && (
    <div className="footer-item">
      <span className="footer-icon">
        <FaGlobe />
      </span>
      <div>
        {[vendorDetails?.city_name,
          vendorDetails?.vendor_state || vendorDetails?.State,
          vendorDetails?.vendor_country || vendorDetails?.Country,
        ]
          .filter(Boolean)
          .join(", ")}
      </div>
    </div>
  )}

{(vendorDetails?.phone_number || vendorDetails?.fullName) && (
  <div className="footer-item">
    <span className="footer-icon">
      <FaPhoneAlt />
    </span>

    <div>
      {[vendorDetails?.fullName, vendorDetails?.phone_number]
        .filter(Boolean)
        .join(", ")}
    </div>
  </div>
)}

  {vendorDetails?.email && (
    <div className="footer-item">
      <span className="footer-icon">
        <FaEnvelope />
      </span>
      <div>{vendorDetails.email}</div>
    </div>
  )}
</div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CustomerBookings;
